<script setup lang="ts">
import InteractiveTopics from "~/components/InteractiveTopics.vue";
import PageContainer from "~/components/ui/PageContainer.vue";
import DateTimeDemo from "~/features/python/ch2/modules/components/DateTimeDemo.vue";
import ImportDemo from "~/features/python/ch2/modules/components/ImportDemo.vue";
import ModulesQuiz from "~/features/python/ch2/modules/components/ModulesQuiz.vue";
import PackageVisualizer from "~/features/python/ch2/modules/components/PackageVisualizer.vue";
import RandomModuleDemo from "~/features/python/ch2/modules/components/RandomModuleDemo.vue";
import { buildComputerCollectionSchema } from "~/features/computer/data/seo/computer-schema";
import { pythonInteractiveCards } from "~/features/python/data/chapter2-interactive";

const relatedCards = pythonInteractiveCards.filter((item) => item.to !== "/11th/computer/python/functions/");

usePageSeo({
  title: "Chapter 2 Python Modules | Ustaad",
  description: "Chapter 2 Python modules with import demo, random and datetime examples, package structure and quick module quiz for class 11 students.",
  keywords: "chapter 2 python modules, import module python class 11, random module python, datetime module python",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Ch 2 Python", item: "/11th/computer/python/" },
    { name: "Modules", item: "/11th/computer/python/modules/" },
  ],
  schemaType: "CollectionPage",
  schemaProperties: buildComputerCollectionSchema({
    about: "Chapter 2 Python Modules",
    items: [
      { name: "Chapter 2 Python", path: "/11th/computer/python/" },
      { name: "Chapter 2 Python Functions", path: "/11th/computer/python/functions/" },
      { name: "Chapter 2 Python Programs", path: "/11th/computer/python/programs/" },
      { name: "Chapter 2 Python MCQs", path: "/11th/computer/python/mcqs/" },
    ],
  }),
});
</script>

<template>
  <PageContainer>
    <div class="space-y-8">
      <section class="rounded-3xl bg-slate-950 p-6 text-white">
        <p class="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300">Python Chapter 2</p>
        <h1 class="mt-2 text-2xl font-bold tracking-tight">Chapter 2 Python Modules</h1>
        <p class="mt-3 text-sm leading-7 text-slate-200">
          Yahan aap dekhoge ke Python bahar se cheez kaise laata hai. Simple examples ke sath `import`, `random` aur `datetime` samajh aayega.
        </p>
      </section>

      <section class="grid gap-6 lg:grid-cols-2">
        <ImportDemo />
        <RandomModuleDemo />
      </section>

      <section class="grid gap-6 lg:grid-cols-2">
        <DateTimeDemo />
        <PackageVisualizer />
      </section>

      <ModulesQuiz />

      <section class="rounded-3xl border border-slate-200 bg-amber-50 p-5 dark:border-amber-900/40 dark:bg-amber-950/20">
        <h2 class="text-lg font-semibold text-slate-900 dark:text-white">Is se kya faida hota hai?</h2>
        <div class="mt-4 space-y-3 text-sm leading-7 text-slate-700 dark:text-slate-300">
          <p>- `import` syntax short question me aasakti hai</p>
          <p>- `random` aur `datetime` examples concept clarity dete hain</p>
          <p>- Functions ke baad modules samajhne se coding questions easy lagte hain</p>
        </div>
      </section>

      <InteractiveTopics
        eyebrow="More Python Topics"
        title="Back to Core Python Topics"
        intro="Modules ke baad chapter ke core exam topics bhi yahan se revise kar sakte hain."
        :cards="relatedCards"
      />
    </div>
  </PageContainer>
</template>
